// src/lib/data-versions.js
// 2026-05-29 EXTRACTED from src/App.jsx (C1 refactor — per-table data-version
// cluster used by the save/sync optimistic-concurrency flow) as a
// behavior-preserving TRANSFORM.
//
// Why extract:
//   - `dataVersions` + its load/save helpers are the per-table version map shared
//     across the network layer (apiGet / apiSave / flushPendingSaves /
//     connectWebSocket). The version number per endpoint is what the backend POST
//     handler uses for optimistic-concurrency conflict resolution (409 on stale
//     version). Keeping them inside the 6741-LOC App.jsx monolith forces every
//     reader/writer to live in-file. Hoisting them into a tiny module-singleton
//     lets the network layer import the SAME state без App.jsx coupling — same
//     precedent as src/lib/connection-state.js, src/lib/tombstones.js and
//     src/lib/local-storage.js.
//
// Read/write contract (ESM live bindings):
//   - `dataVersions` is a `const` PLAIN OBJECT, NEVER reassigned — only mutated in
//     place (dataVersions[endpoint] = N). The imported reference points at the SAME
//     object across modules, so NO setter is needed (and adding one would be a
//     footgun — it MUST stay a single shared instance, like the old in-file
//     `const dataVersions`). A duplicate object would silently split version
//     tracking between modules → spurious 409 version conflicts on save.
//
// Threading model: single-threaded JS — no race on these mutations.
//
// NOTE: this is a DIFFERENT concern from the build-hash reload-check
// (INITIAL_BUILD_HASH / PREV_VERSION_KEY / prevVersion), which stays in App.jsx —
// that compares the app VERSION/bundle hash, not per-table data versions.

import { LS_VERSIONS_KEY } from './local-storage.js';

// Load persisted data versions from localStorage (survives page refresh)
function loadPersistedVersions() {
  try {
    const stored = localStorage.getItem(LS_VERSIONS_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (e) { return {}; }
}

// Save data versions to localStorage
export function savePersistedVersions(versions) {
  try {
    localStorage.setItem(LS_VERSIONS_KEY, JSON.stringify(versions));
  } catch (e) {}
}

// ── Version tracking per table (for conflict resolution) ──
// Load persisted versions from localStorage to survive page refreshes.
// SHARED singleton — mutated in place (dataVersions[endpoint] = N), NEVER reassigned.
export const dataVersions = loadPersistedVersions();

export { loadPersistedVersions };
